import * as React from 'react';
import * as anime from 'animejs';

export class UnderConstruction extends React.Component {
  componentDidMount() {
    /* Animate splash header of the section to have a nice fade in */
    const splashAnimation = anime.timeline();

    splashAnimation.add({
      targets: 'main',
      opacity: [0, 1],
      duration: 800,
      delay: 800,
      easing: 'easeOutQuint'
    });
  }

  render() {
    return (
      <section>
        <section className="wrapper">
          <div className="copy">
            <h6 className="t-delta u-opacity--90">
              Under Construction
            </h6>
            <p className="t-epsilon u-opacity--60">
              Website is under development.
            </p>            
          </div>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Routing/views/UnderConstruction.tsx